<div class="header" *ngIf="!isHome" [ngClass]="{ 'fullmenu-header-active': globalService.FullMenu }">
  <mat-toolbar class="top-toolbar" [ngClass]="{ 'fullmenu-header-active': globalService.FullMenu }">
    <mat-toolbar-row
      class="top-toolbar-color"
      style="position: relative"
      [ngClass]="{ 'fullmenu-header-active': globalService.FullMenu }"
    >
      <div
        style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; flex: 1 1 0%"
      >
        <!-- Navbar escondida para correta leitura do crawler Google -->
        <nav
          aria-label="Navegação principal"
          style="
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            border: 0;
          "
        >
          <ul>
            <li><a href="/">Página Inicial</a></li>
            <li><a href="/seguros/responsabilidade-civil/alojamento-local">RC Alojamento Local</a></li>
            <li><a href="/seguros/viagem">Seguro de Viagem</a></li>
            <li><a href="/seguros/responsabilidade-civil/armas-e-cacadores">RC Armas e Caçadores</a></li>
          </ul>
        </nav>
        <div
          style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-start; align-items: center"
        >
          <a
            routerLink="/home"
            style="display: flex; flex-direction: row; justify-content: center; align-items: center"
          >
            <img
              *ngIf="!globalService.isMobileDevice"
              [src]="globalService.logotipoCantoSuperiorEsquerdo"
              alt="Seguros Virtual"
              width="220"
              height="66"
              (click)="globalService.FullMenu = false; scrollToTop()"
              loading="lazy"
            />
            <img
              *ngIf="globalService.isMobileDevice"
              [src]="globalService.logotipoCantoSuperiorEsquerdo"
              alt="Seguros Virtual"
              width="160"
              height="48"
              (click)="globalService.FullMenu = false; scrollToTop()"
              loading="lazy"
            />
          </a>
        </div>

        <div
          *ngIf="globalService.loggedUserClass?.Admin"
          style="
            display: flex;
            flex-direction: row;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1001;
          "
        >
          <app-activeadmin></app-activeadmin>
        </div>

        <div
          *ngIf="isUserLoggedIn && globalService.loggedUserClass"
          style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; margin-right: 5px"
        >
          <!-- pages.component.html -->

          <div style="position: relative; display: flex; align-items: center">
            <app-user-avatar
              [photoPath]="
                globalService.loggedUserClass?.customerClass?.Photo ||
                globalService.loggedUserClass?.commercialClass?.Photo
                  ? (globalService.loggedUserClass?.customerClass?.Photo ||
                      globalService.loggedUserClass?.commercialClass?.Photo | convertImageToUrl)
                  : null
              "
              [userName]="
                globalService.loggedUserClass?.customerClass?.firstLastName ||
                globalService.loggedUserClass?.customerClass?.Name ||
                globalService.loggedUserClass?.commercialClass?.Name ||
                globalService.loggedUserClass?.Nome ||
                ''
              "
              size="header"
              (click)="globalService.FullMenu = false; scrollToTop(); toggleUserMenu()"
              (contextmenu)="onHeaderAvatarContextMenu($event)"
              style="cursor: pointer; margin-right: 0px"
            ></app-user-avatar>

            <!-- Trigger invisível para posicionar o menu de contexto no clique do botão direito -->
            <div
              style="visibility: hidden; position: fixed; pointer-events: none"
              [style.left]="headerContextMenuPosition.x"
              [style.top]="headerContextMenuPosition.y"
              [matMenuTriggerFor]="headerPhotoMenu"
              #headerPhotoMenuTrigger="matMenuTrigger"
            ></div>

            <input
              #headerPhotoFileInput
              type="file"
              accept="image/*"
              style="display: none"
              (change)="onHeaderPhotoFileSelected($event)"
            />

            <mat-menu #headerPhotoMenu="matMenu" class="sv-photo-context-menu" panelClass="sv-photo-context-menu-panel">
              <button mat-menu-item (click)="globalService.FullMenu = false; scrollToTop(); toggleUserMenu()">
                <mat-icon style="color: #1b1464">account_circle</mat-icon>
                <span>{{ 'USERMENU.PHOTO_MENU.OPEN_PROFILE' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="onHeaderTakePicture()">
                <mat-icon style="color: #1b1464">photo_camera</mat-icon>
                <span>{{ 'USERMENU.PHOTO_MENU.TAKE_PHOTO' | translate }}</span>
              </button>
              <button mat-menu-item (click)="headerPhotoFileInput.click()">
                <mat-icon style="color: #1b1464">file_upload</mat-icon>
                <span>{{ 'USERMENU.PHOTO_MENU.UPLOAD_FROM_DEVICE' | translate }}</span>
              </button>
              <button *ngIf="hasHeaderProfilePhoto" mat-menu-item (click)="onHeaderViewPhoto()">
                <mat-icon style="color: #1b1464">visibility</mat-icon>
                <span>{{ 'USERMENU.PHOTO_MENU.VIEW_PHOTO' | translate }}</span>
              </button>
              <mat-divider *ngIf="hasHeaderProfilePhoto"></mat-divider>
              <button *ngIf="hasHeaderProfilePhoto" mat-menu-item class="danger-item" (click)="onHeaderRemovePhoto()">
                <mat-icon style="color: #dc3545">delete_outline</mat-icon>
                <span style="color: #dc3545">{{ 'USERMENU.PHOTO_MENU.REMOVE_PHOTO' | translate }}</span>
              </button>
            </mat-menu>

            <div
              *ngIf="totalAlerts > 0"
              style="
                position: absolute;
                top: -4px;
                right: -4px;
                background-color: #f44336;
                color: white;
                border-radius: 50%;
                min-width: 18px;
                height: 18px;
                font-size: 11px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border: 2px solid white;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                z-index: 10;
                padding: 0 4px;
              "
              (click)="$event.stopPropagation(); navigateToAlerts()"
              matTooltip="Tem {{ totalAlerts }} alertas pendentes"
            >
              {{ totalAlerts }}
            </div>
          </div>

          <i
            *ngIf="!globalService.FullMenu"
            (click)="openFullMenu(); options.close(); scrollToTop()"
            style="cursor: pointer; margin-left: 35px; color: #ffffff; font-size: 30px"
            class="fa fa-bars"
            aria-hidden="true"
            [title]="'MENU.OPEN' | translate"
          ></i>

          <i
            *ngIf="globalService.FullMenu"
            (click)="openFullMenu(); options.close(); scrollToTop()"
            style="cursor: pointer; margin-left: 35px; color: #ffffff; font-size: 35px"
            class="fa fa-times"
            aria-hidden="true"
            [title]="'MENU.CLOSE' | translate"
          ></i>
        </div>

        <div
          *ngIf="!isUserLoggedIn"
          style="
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            margin-right: 0;
            font: 13px;
          "
        >
          <a
            routerLink="/login"
            (click)="globalService.FullMenu = false; scrollToTop(); authService.logout(false, '', false)"
            style="cursor: pointer; display: flex; align-items: center"
            [attr.aria-label]="'MENU.SIGN_OUT' | translate"
          >
            <img
              style="font-size: medium; color: #000000; pointer-events: none"
              src="assets/icons/Logout.webp"
              loading="lazy"
              [alt]="'MENU.SIGN_OUT' | translate"
            />
          </a>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>

<mat-drawer-container hasBackdrop class="page-wrapper" style="width: 100%">
  <mat-drawer-content>
    <div *ngIf="globalService.isChangeNIFInProgress" class="overlay"></div>
    <div class="main-content" [hidden]="globalService.FullMenu">
      <router-outlet></router-outlet>
    </div>
    <app-footer [hidden]="globalService.FullMenu"></app-footer>
    <app-fullmenu *ngIf="globalService.FullMenu"></app-fullmenu>
  </mat-drawer-content>

  <mat-drawer
    #options
    position="end"
    mode="over"
    class="options"
    [style.display]="globalService.isMobileDevice ? 'flex' : 'block'"
    [style.flex-direction]="globalService.isMobileDevice ? 'column' : 'row'"
    [style.align-items]="globalService.isMobileDevice ? 'stretch' : 'normal'"
    [style.justify-content]="globalService.isMobileDevice ? 'stretch' : 'normal'"
    [ngClass]="{ fullscreen: globalService.isMobileDevice }"
  >
    <app-usermenu
      *ngIf="isUserLoggedIn && globalService.loggedUserClass"
      [option]="options"
      (outuserPhoto)="changedPhoto($event)"
    ></app-usermenu>
  </mat-drawer>
</mat-drawer-container>
